import { Component,  OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, from, Observable, of, Subscription } from 'rxjs';  // RxJS 6 syntax


import { PS_Supplier_Regul_Docs_Result, Supplier, DocumentStatut, SimpleReponseResult, PS_Relance_Doc_Result, PafDocument, DocTyp, SendRegulDocsMailsParameters } from '../../../all-models';
import { ContactsService, DocumentsService, SharedDataService, SuppliersService } from '../../../all-services';
import { SupplierDetailsStepBase, checkValidityEvent } from '../supplier-details/suppliers-details-step-base';
import { SaveStepParam } from '../supplier-details/SaveStepParam';
import { map } from 'rxjs/operators';
import moment from 'moment';

@Component({
  selector: 'app-supplier-regul-docs',
  templateUrl: './supplier-regul-docs.component.html',
  styleUrls: ['./supplier-regul-docs.component.scss']
})
export class SupplierRegulDocsComponent extends SupplierDetailsStepBase implements OnInit, OnChanges, OnDestroy {
 firstLoad: boolean = true;
  lstDocTyps: DocTyp[]=[] ;
  lstDocStatuts: DocumentStatut[]=[];  
  lstSupplierRegDoc: PS_Supplier_Regul_Docs_Result[] = [];
  isLoading: boolean = false;
  constructor(
    public docsSvc: DocumentsService,
    public sharedDatasSvc: SharedDataService,
    public suppliersSvc: SuppliersService,
    public route: ActivatedRoute,
    public contactsSvc: ContactsService) {
    super(sharedDatasSvc, docsSvc, suppliersSvc, route, contactsSvc);
  }

  pafDocuments:PafDocument[]=[];
  ngOnInit(): void {
    this.firstLoad= true;
    forkJoin(
      [this.docsSvc.getPafDocuments(),
      this.docsSvc.getDocTyps(),
      this.docsSvc.getDocumentStatuts()
      
      ]).subscribe(res=>{
        this.pafDocuments=res[0];
        this.lstDocTyps=res[1];
        this.lstDocStatuts=res[2];
      }); 

    this.subscriptions.push(this.sharedDatasSvc.loggedProfilChange.subscribe(res => {
      this.reloadListDocs();
    }));
  }

  private _lstSupplierRegDocBackup? : PS_Supplier_Regul_Docs_Result[]= undefined;
  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes['supplier']) {
      this.reloadListDocs();
    }
    if (changes['ocurrentstep'] && this.ocurrentstep) {
      this.ocurrentstep.onUndoScreen=():Promise<void>=>{
        return this._sendRegulDocsMailAndReload();
      };
      setTimeout(() => {
        this.ocurrentstep.showSaveButton = (): boolean=>{ return this._ShowSaveButton()};
     }, 0);
    }
  }

  private _ShowSaveButton = ():any =>  {
    return !this.docsReglementairesDisabled();
  }

  /**
   * contrôle d'accès à la modification des doc réglementaires
   * Accès ouvert is :
   *   - En cours de création
   *   - Est autorisé à modifier le fournisseur ET un profil qui autorise la modification des doc réglementaires
   * @returns boolean
   */
  docsReglementairesDisabled(): boolean {
    if (this.isCreatingSupplier) return false;
    if (!this.canModifySupplier()) return true;
    return !this.sharedDatasSvc.checkProfilAccessPafSettings('FICHE_DOC_REGLEMENTAIRE');
    //return ['ACH_OPERAT', 'ACH_OPERAT_2', 'ACH_FAMHA', 'CTRL_QUAL', 'COMPTA', 'ADMIN','FOURNISSEUR'].indexOf(this.sharedDatasSvc.profil?.Cod) < 0;
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }


  /**
   * Recharge les documents réglementaires et qualité du fournisseur et initialise la liste de sauvegarde
   * @returns Promise<PS_Supplier_Regul_Docs_Result[]> Liste des documents réglementaires
   */
  reloadListDocs(): Promise<PS_Supplier_Regul_Docs_Result[]> {
    return new Promise<PS_Supplier_Regul_Docs_Result[]>((resolve, reject) => {
      this.sharedDatasSvc.WindowLock();
      this._reloadRegulDocs()
        .subscribe({
          next:(res)=>{
            if (!this._lstSupplierRegDocBackup) {
              this._lstSupplierRegDocBackup = [...res];
            }
            resolve(res||[]);
          },
          error:(err)=>reject(err),
          complete:()=>this.sharedDatasSvc.WindowUnlock()
        });
      });    
  }

 
  private _reloadRegulDocs(): Observable<PS_Supplier_Regul_Docs_Result[] | null  > {
    let observable: Observable<PS_Supplier_Regul_Docs_Result[] | null> = null;
    if (this.supplier.Id > 0) {
      this.isLoading = true;
      observable = forkJoin([
        this.docsSvc.getSupplierRegulDocs(this.sharedDatasSvc.lngCod, this.supplier.Id, this.firstLoad),
        this.docsSvc.getSupplierDocuments(this.supplier.Id)
      ]).pipe(
        map((res: any[]) => {
          this.lstSupplierRegDoc = res[0].filter((f: any) => f.TopDelete == 0);
          this.supplier.SupplierDocuments = res[1];
          this.isLoading = false;  
          this.firstLoad = false;  
          return res[0];    
        }));
    } else {
      this.lstSupplierRegDoc = [];
      observable = of(null);
    }
    return observable;
  }


  

  /**
   * Renvoie le statut d'un document
   * @param doc Document à contrôler
   * @returns DocumentStatut si doc trouvé, sinon undefined
   */
  getStatutDoc(doc: PS_Supplier_Regul_Docs_Result): DocumentStatut | undefined {
    return this.lstDocStatuts.find(s => s.Id == doc.StatutId);
  }

  /**
   * Renvoie true si le document réglementaire en paramètre est en statut A_DEPOSER ou EXPIRE
   * @param doc Document de type PS_Supplier_Regul_Docs_Result
   * @returns bool
   */
  documentManquant(doc: PS_Supplier_Regul_Docs_Result): boolean {
    return ['A_DEPOSER', 'EXPIRE'].some(cod => this.getStatutDoc(doc).Cod == cod);
  }
  documentNonvalide(doc: PS_Supplier_Regul_Docs_Result): boolean {
    return ['A_DEPOSER', 'NON_CONFORME'].some(cod => this.getStatutDoc(doc).Cod == cod);
  }

  CanSaveDocuments(): boolean {
    if (['010', '100', '150'].indexOf(this.supplierStatutCod) >= 0) {
      return (this.sharedDatasSvc.profil?.Cod != 'FOURNISSEUR') || !this.lstSupplierRegDoc.some(d => this.documentNonvalide(d));
    } else {
      return true;
    }
  }

  
   save(param: SaveStepParam) {
    if (param.nextAction == 'forceScreen') {
      super.save(param);
      return;
    }
    param.canSave = this.CanSaveDocuments();
    if (param.nextAction == 'next' && !param.canSave) {
      this.sharedDatasSvc.pafAlert('Msg_Documents_manquants');
      return;
    }
    this._saveRegulDocsComments(param)
    .then(() => this._sendRegulDocsMailAndReload())
    .then(() => {
      super.save(param);
    })
    .catch((err) => {
      this.sharedDatasSvc.alertSubscriptionReject(err);
    });    
  }


  private async _saveRegulDocsComments(param: SaveStepParam): Promise<SimpleReponseResult> {
    return new Promise<SimpleReponseResult>((resolve, reject) => {
      let patchParam: Supplier = new Supplier();
      patchParam.Id = this.supplier.Id;
      patchParam.DocComments = this.supplier.DocComments;
      patchParam.RefStep = this.supplier.RefStep + (param.nextAction != 'screen'?1:0);
      this.suppliersSvc.PatchSimpleValues(this.supplier.Id, patchParam).subscribe({
          next:(result: SimpleReponseResult) => {
              if (!result.Ok) {
                this.sharedDatasSvc.alert(result.Message);
                reject(result.Message);
              } else {
                resolve(result);
              }
            },
          error:(err)=>reject(err)
        });
    });
  }

  /** Envoie les mails liés aux changements de documents et recharge la liste
   * @return Promise<void>
   */
  private async _sendRegulDocsMailAndReload(refDocId: number | undefined = undefined) : Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.sharedDatasSvc.WindowLock();
      let parameters: SendRegulDocsMailsParameters = new SendRegulDocsMailsParameters();
      parameters.SupplierId = this.supplier.Id;
      if (!!refDocId) parameters.RefDocId = refDocId;
      parameters.MailModelCod = 'DOCS_NON_CONFORMES';
      parameters.TopEnvoiMail = (refDocId === undefined);

      const okCallBack:()=>any = () => {
        if (parameters.TopEnvoiMail) {
          this._lstSupplierRegDocBackup = undefined;
        }
        this.reloadListDocs().then(() => {
          resolve();
        });
      };

      this.suppliersSvc.SendRegulDocsMails(this.supplier.Id, parameters)
        .subscribe({
        next: (res: SimpleReponseResult) => {
          this.sharedDatasSvc.WindowUnlock();
          if (res.Ok) {
            // il y a un envoi effectif de mail uniquement si le résultat est Ok et accompagné d'un message
            if ( this.sharedDatasSvc.portalType=='INTRANET' &&  res.Message!=''){
                this.sharedDatasSvc.informe(res.Message,()=>okCallBack());
            } else {
              okCallBack();
            }
          } else {
            reject(res.Message);
          }
        },
        error: (err) => {
          this.sharedDatasSvc.WindowUnlock();
          reject(err);
        }
      });
    });
  }


  /**
   * Renvoie la liste des documents modifiés depuis le dernier chargement/sauvegarde (présence d'un fichier avec date de statut différente)
   */
  get modifiedDocs(): PS_Supplier_Regul_Docs_Result[] {
    if (!this._lstSupplierRegDocBackup) {
      return [];
    } 
    return this.lstSupplierRegDoc.filter(d => this.isMdifiedDoc(d));
  }

  isMdifiedDoc(doc: PS_Supplier_Regul_Docs_Result): boolean {
    if (!this._lstSupplierRegDocBackup) return false;
    if (!doc.FullPath) return false;
    const backupDoc = this._lstSupplierRegDocBackup.find(d => d.RefDocId == doc.RefDocId);
    if (!backupDoc) return false;
    if (moment(backupDoc.DatStatut).format('yyyyMMddHHmmss') != moment(doc.DatStatut).format('yyyyMMddHHmmss')) {
      return true;
    };
    return false;
  }

  onCheckValidity(event: checkValidityEvent): Observable<boolean | undefined> {
    if (event.stepNum != this.screenValidity.step) return of(undefined);
    let reloadObservable: Observable<PS_Supplier_Regul_Docs_Result[]>;
    if (this._preventDocReloadOncheckValidity) {
      this._preventDocReloadOncheckValidity = false;
      reloadObservable = of(this.lstSupplierRegDoc);
    } else {
      reloadObservable = from(this.reloadListDocs());
    }
    return reloadObservable
      .pipe(
        map(res => {
          let isValid: boolean = true;
          if (['CTRL_QUAL', 'COMPTA', 'ADMIN'].indexOf(this.sharedDatasSvc.profil?.Cod) >= 0) {
            isValid = !res.some(d => this.documentNonvalide(d));
            isValid = isValid || this.CanSaveDocuments();
            if (!isValid) {
              this.screenValidity.errorMessages.push('Msg_doc_manquant_ou_non_conforme');
            }
          } else if (['FOURNISSEUR'].indexOf(this.sharedDatasSvc.profil?.Cod) >= 0) {
            if (this.supplierStatutCod == '100') {
              isValid = !res.some(d => this.documentManquant(d));
              isValid = isValid || this.CanSaveDocuments();
              if (!isValid) {
                this.screenValidity.errorMessages.push('Msg_doc_manquants');
              }
            } else {
              isValid = !res.some(d => this.documentNonvalide(d));
              isValid = isValid || this.CanSaveDocuments();
              if (!isValid) {
                this.screenValidity.errorMessages.push('Msg_doc_manquant_ou_non_conforme');
              }
            }
          }
          return isValid;
        })
      );
  }


 private _preventDocReloadOncheckValidity: boolean = false;
  supplierDocChange(doc: PS_Supplier_Regul_Docs_Result): void {
    if (!doc) return;  
    this._sendRegulDocsMailAndReload(doc.RefDocId)
    .then(()=>{
      this._preventDocReloadOncheckValidity = true;
      this.onCheckValidity({stepNum: this.currentStep, showerrorMessage:true}).subscribe();
    },
    (err)=>{
      this.sharedDatasSvc.alertSubscriptionReject(err);
    });
  }

  docReadonly(doc: PS_Supplier_Regul_Docs_Result): boolean {
   
    return this.docsReglementairesDisabled() || !this.isEditing();
  }

  relanceDocList:PS_Relance_Doc_Result[]=[];
  
  getRelanceDocList(): void {
    this.sharedDatasSvc.WindowLock();
    this.suppliersSvc.GetRelanceDocList(this.supplier?.Id)
      .subscribe({
        next: res => {
          this.relanceDocList = res;
          this.relanceDocListSubmitted = true;
        },
        error: (error) => this.sharedDatasSvc.alert(error)
        ,
        complete: () => this.sharedDatasSvc.WindowUnlock()
      });
  }

  relanceDocListSubmitted:boolean=false;
  get NoRelanceDoc(): boolean {
    return this.relanceDocList.length==0;
  }

  RelanceDoc2PafDoc(doc:PS_Relance_Doc_Result):PafDocument | undefined{
    return this.pafDocuments.find(d=>d.Id==doc.RefDocId);
  }

  relanceDocs(): void {
    this.sharedDatasSvc.WindowLock();
    this.suppliersSvc.PostRelanceDocuments(this.supplier?.Id)
      .subscribe({
        next: (res: SimpleReponseResult) => {
          let msg: string = 'Traitement ' + (res.Ok ? 'OK' : 'en erreur') + '|';
          msg += (res.Message || '');
          msg = msg.split('|').join('<BR>');
          this.relanceDocListSubmitted = false;
          from(this.reloadListDocs())
            .subscribe({
              next: any => {
                this.sharedDatasSvc.informe(msg, () => { this.getRelanceDocList() });
              }
            });
        },
        error: err => this.sharedDatasSvc.alertSubscriptionReject(err)
      }
      );
  }

}
